import requestMiddleware from './request';
import datadogMiddleware from './datadog';
export const coreMiddlewares = [requestMiddleware, datadogMiddleware];
export default coreMiddlewares;
